///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="referencesService.ts"/>

module ProcessEditor {
    var attributeName = "frendsValidateReference";
    export function frendsValidateReference(referenceService: ReferencesService): ng.IDirective {
        return {
            restrict: "A",
            require: 'ngModel',
            scope: false,
            link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel: ng.INgModelController) {
                ngModel.$validators["reference"] = (modelValue, viewValue) => {
                    if (ngModel.$isEmpty(modelValue) || ngModel.$pristine) {
                        // consider empty and untouched models to be valid, 
                        // the pristine check is especially needed for environment variable references which are populated
                        // asynchronously, causing the initial validation to fail due to missing environment references
                        return true;
                    }
                    var nodeId = attributes[attributeName];

                    var availableReferences = referenceService.getAllReferences(nodeId);
                    var resultReferenceRegex = /(#[\w]+)(?:(?:\.([^\s\.\[\]\-\+\&\)]+))|(?:\[([^\]]+)\]))/ig;
                    var refMatches;
                    while (refMatches = resultReferenceRegex.exec(modelValue)) {
                        var refType = refMatches[1];
                        var refString = refMatches[2] || refMatches[3];

                        var refs = availableReferences[refType.toLowerCase()];
                        if (!refs) {
                            return true;
                        }
                        if (!_.some(refs, (value) => {
                            var compareValue = value.toLowerCase();
                            var refWithDot = refType.toLowerCase() + "." + refString.toLowerCase();
                            var refWithBracket = refType.toLowerCase() + "[" + refString.toLowerCase() + "]";

                            return compareValue === refWithDot || compareValue === refWithBracket;
                        })) {
                            return false;
                        }
                    }
                    return true;
                };
            }
        }
    }

    ProcessEditor.app.directive(attributeName, ["ReferencesService", ProcessEditor.frendsValidateReference]);

}